module.exports = __webpack_public_path__ + "static/media/sell-product.1f402b3c.png";